 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		6: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		6: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"b637e9a5","1":"commons","2":"styles","3":"2b0ab78abe49db687cf6a804494cb227d4d2d91f","4":"2e83a1e76051ec173c7f0a57fe708aa9c405daca","5":"6a57363c7e92b245aee0c1f0c11d24cb97c1e758","8":"component---src-pages-404-js","9":"component---src-pages-about-us-index-js","10":"component---src-pages-about-us-our-plants-js","11":"component---src-pages-collaboration-custom-products-js","12":"component---src-pages-collaboration-finished-products-js","13":"component---src-pages-collaboration-index-js","14":"component---src-pages-contact-index-js","15":"component---src-pages-for-employees-career-js","16":"component---src-pages-for-employees-cloud-js","17":"component---src-pages-for-employees-e-pracownik-js","18":"component---src-pages-for-employees-employee-zone-js","19":"component---src-pages-index-1-js","20":"component---src-pages-index-3-js","21":"component---src-pages-index-js","22":"component---src-pages-indextext-js","23":"component---src-pages-our-coffees-coffee-beans-js","24":"component---src-pages-our-coffees-ground-coffee-js","25":"component---src-pages-our-coffees-index-js","26":"component---src-pages-our-coffees-instant-coffee-js","27":"component---src-pages-our-packaging-design-js","28":"component---src-pages-our-packaging-packaging-capsules-js","29":"component---src-pages-our-packaging-packaging-ground-packaging-js","30":"component---src-pages-our-packaging-packaging-index-js","31":"component---src-pages-our-packaging-packaging-instant-packaging-js","32":"component---src-pages-our-packaging-packaging-whole-bean-packaging-js","33":"component---src-pages-privacy-policy-js","34":"component---src-pages-quality-index-js","35":"component---src-pages-ue-index-js"}[chunkId]||chunkId) + "-" + {"0":"95d0fa387ee300f3b746","1":"be783eed1088406076ee","2":"7d4153d260c0197f0043","3":"daa54d45bc447fe963fe","4":"766810ca13cc8e31612d","5":"961a5b7060e57dc77e26","8":"bb2f8bde45c567f09936","9":"1cf1c82a0cfac362358d","10":"63a007274dbc83e8d751","11":"1580c76991206580d548","12":"35326b31a309a290cfde","13":"bf898e4543f2670a39e9","14":"94e174bef630b0211be1","15":"11e2f1c56fd2ba9c18e6","16":"2495c42bdcf3557215d8","17":"d8b9114c0c66a3b79820","18":"d8c4eb1c5d0c23bc1d47","19":"294662235cb756871bcb","20":"7af547973988c90b6608","21":"d8072fd7420df00191d6","22":"0ad904559ee6157c81df","23":"d7999531470063e9b9fa","24":"be25c05731e02657e5db","25":"0a796627259ce46a6505","26":"8c14180313482c419314","27":"560bd6d0683e615e7a5b","28":"4423d531c3010baa84e0","29":"bc7251c35915011c1b92","30":"7224127455f6eb2b6761","31":"ba311f717a2b07f30c19","32":"254293cbdc8e92e493b2","33":"c01e91eb44d6ea53cc8d","34":"c0a1e7b58da33b328c31","35":"1c4f05e827f5bff31e40"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"2":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"b637e9a5","1":"commons","2":"styles","3":"2b0ab78abe49db687cf6a804494cb227d4d2d91f","4":"2e83a1e76051ec173c7f0a57fe708aa9c405daca","5":"6a57363c7e92b245aee0c1f0c11d24cb97c1e758","8":"component---src-pages-404-js","9":"component---src-pages-about-us-index-js","10":"component---src-pages-about-us-our-plants-js","11":"component---src-pages-collaboration-custom-products-js","12":"component---src-pages-collaboration-finished-products-js","13":"component---src-pages-collaboration-index-js","14":"component---src-pages-contact-index-js","15":"component---src-pages-for-employees-career-js","16":"component---src-pages-for-employees-cloud-js","17":"component---src-pages-for-employees-e-pracownik-js","18":"component---src-pages-for-employees-employee-zone-js","19":"component---src-pages-index-1-js","20":"component---src-pages-index-3-js","21":"component---src-pages-index-js","22":"component---src-pages-indextext-js","23":"component---src-pages-our-coffees-coffee-beans-js","24":"component---src-pages-our-coffees-ground-coffee-js","25":"component---src-pages-our-coffees-index-js","26":"component---src-pages-our-coffees-instant-coffee-js","27":"component---src-pages-our-packaging-design-js","28":"component---src-pages-our-packaging-packaging-capsules-js","29":"component---src-pages-our-packaging-packaging-ground-packaging-js","30":"component---src-pages-our-packaging-packaging-index-js","31":"component---src-pages-our-packaging-packaging-instant-packaging-js","32":"component---src-pages-our-packaging-packaging-whole-bean-packaging-js","33":"component---src-pages-privacy-policy-js","34":"component---src-pages-quality-index-js","35":"component---src-pages-ue-index-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"d0b2f419b5c6377b3c99","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
